import { rem } from 'polished';

import { GeneratedTheme, Theme } from '../../types';

const mapCoreTheme = (core: GeneratedTheme['core']): Theme['core'] => {
  const mappedCore: Theme['core'] = {
    ...core,
    spacing: {
      '3x': rem(6),
      ...core.spacing,
    },
    radius: {
      full: '9999px',
      ...core.radius,
    },
    iconSize: {
      s: rem(16),
      m: rem(24),
      l: rem(32),
    },
    typography: {
      fontFamily: {
        regular: `Rubik, Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`,
        numeric: "'Roboto Mono', monospace",
      },
      fontSize: {
        xs: rem(10),
        sm: rem(12),
        md: rem(14),
        base: rem(16),
        lg: rem(18),
        xl: rem(20),
        '2xl': rem(24),
        '3xl': rem(30),
        '4xl': rem(40),
        '5xl': rem(48),
      },
      fontWeight: {
        thin: 100,
        extraLight: 200,
        light: 300,
        regular: 400,
        medium: 500,
        semiBold: 600,
        bold: 700,
        extraBold: 800,
        black: 900,
      },
    },
  };

  return mappedCore;
};

export default mapCoreTheme;
